import QueueableRequest from './QueueableRequest';
import { REQUEST_METHOD_POST } from '../../helpers/constants';
import { bindParamsToRoute } from '../../helpers/url';
import { MFA_COMPLETE } from '../../config/api';

export default class MfaCompleteRequest extends QueueableRequest {
  constructor(msisdn, mfaToken, tan) {
    super(bindParamsToRoute(MFA_COMPLETE, { msisdn }), {
      method: REQUEST_METHOD_POST,
      headers: {
        'X-Multifactor-Token': mfaToken,
      },
      payload: {
        tan,
      },
    });
  }

  isPreventDefaultErrorHandling() {
    return true;
  }
}
